import i18n from '../locales/index'
import Web3, { FMT_BYTES, FMT_NUMBER } from "web3";

// 创建默认的 Web3 实例
let web3 = null;

// 初始化 Web3 提供者
function initializeWeb3() {
    try {
        // 优先使用 window.myprovider，然后是 window.ethereum，最后是本地提供者
        const provider = window.myprovider || window.ethereum || 
            new Web3.providers.HttpProvider("http://127.0.0.1:8545/");
        
        if (provider) {
            web3 = new Web3(provider);
            console.log('Web3 provider initialized successfully');
            return true;
        }
    } catch (error) {
        console.error('Error initializing Web3 provider:', error);
    }
    return false;
}

// 立即尝试初始化
if (!initializeWeb3()) {
    // 如果初始化失败，设置定时器重试
    var timer = setInterval(() => {
        if (window.myprovider || window.ethereum) {
            if (initializeWeb3()) {
                clearInterval(timer);
            }
        }
    }, 100);
    
    // 设置超时，避免无限重试
    setTimeout(() => {
        clearInterval(timer);
        if (!web3) {
            console.warn('Web3 provider initialization timeout, using fallback');
            web3 = new Web3(new Web3.providers.HttpProvider("http://127.0.0.1:8545/"));
        }
    }, 10000); // 10秒超时
}

export default web3;